/**
 * SE2 · Menu drawer — "Recently viewed".
 * Figma o2LnJa3tlbPwKEorUzEDKv 547:83 (section) / 547:85 (recent-product-card) inside 547:4.
 *
 * Paints the list from the card payloads RecentlyViewed records on product pages. Shopify has no public
 * by-id product endpoint, so the alternative would be a section round trip on every drawer open; recording
 * title, url, image and price at view time keeps this to zero network calls.
 *
 * The section ships hidden and is only revealed once there is at least one card, so a first-time visitor
 * never sees an empty shell, and a shopper with JavaScript off simply never sees the section.
 */
import { RecentlyViewed } from '@theme/recently-viewed-products';

const LIMIT = 2;

function render() {
  const section = document.querySelector('[data-se2-drawer-recent]');
  const list = document.querySelector('[data-se2-drawer-recent-list]');
  if (!section || !list) return;

  let cards = [];
  try {
    cards = RecentlyViewed.getCards().slice(0, LIMIT);
  } catch (error) {
    cards = [];
  }
  if (!cards.length) {
    section.hidden = true;
    return;
  }

  list.replaceChildren(
    ...cards.map((card) => {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.className = 'se2-drawer__recent-card';
      a.href = card.url || '#';

      if (card.image) {
        const figure = document.createElement('span');
        figure.className = 'se2-drawer__recent-media';
        const img = document.createElement('img');
        img.src = card.image;
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        // 547:86 product-thumbnail is 48×48
        img.width = 48;
        img.height = 48;
        figure.appendChild(img);
        a.appendChild(figure);
      }

      const meta = document.createElement('span');
      meta.className = 'se2-drawer__recent-meta';

      const title = document.createElement('span');
      title.className = 'se2-drawer__recent-name';
      title.textContent = card.title || '';
      meta.appendChild(title);

      if (card.price) {
        const price = document.createElement('span');
        price.className = 'se2-drawer__recent-price';
        // 547:85 draws "From $34.99"; the prefix belongs only to a product whose variants differ in price
        price.textContent = card.priceVaries ? `From ${card.price}` : card.price;
        meta.appendChild(price);
      }

      a.appendChild(meta);
      li.appendChild(a);
      return li;
    })
  );

  section.hidden = false;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', render, { once: true });
} else {
  render();
}
